import { SpinnerSize } from './loading.types'

export const sizeMap: Record<'sm' | 'md' | 'lg' | 'xl', number> = {
    sm: 16,
    md: 32,
    lg: 48,
    xl: 64,
}

// optional utility function to convert SpinnerSize to pixel size
export const getPixelSize = (size?: SpinnerSize): number | undefined => {
    if (!size) return sizeMap.md // default md

    // Type guard: only map if size is 'sm'|'md'|'lg'|'xl'
    if (['sm', 'md', 'lg', 'xl'].includes(size)) {
        return sizeMap[size as keyof typeof sizeMap]
    }

    // Otherwise it’s a FA size string like '2x', '6x', etc.
    return undefined
}
